module.exports = __webpack_public_path__ + "static/media/إستئجار سيارة في سويسرا.b6d227de.jpg";